import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';

// RxJs
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

// NgRX
import { Store } from '@ngrx/store';
import { AppState } from '@core/store/reducers';
import { selectSessionUserState } from '@core/store/selectors/session.selectors';

// Models
import { UserRole } from '@core/models/maintainer.interface';



@Injectable({
  providedIn: 'root'
})
export class RoleGuard implements CanActivate {

  constructor(
    private readonly router: Router,
    private readonly store: Store<AppState>
  ) { }


  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> {
    return this.store.select(selectSessionUserState).pipe(
      map(user => {
        if (route.data?.['roles']?.includes(user?.role)) {
          return true;

        } else { return this.router.createUrlTree(['home']); }})
    );
  }
}
